import { COUPON_APPLY_FAILED, COUPON_REMOVE_FAILED } from "~/lib/constants";

/**
 * COM-63 — the envelope the basket route's contained `clientAction` returns
 * for a network-level submission failure. Shaped as a `validationError` so
 * every settle observer takes its failure branch.
 *
 * Empty `globalErrors` makes `extractValidationMessage` return null, so the
 * AddedToBasketFlyout watcher falls back to its per-action copy — right for
 * add / update / remove. The coupon intents are the exception: the flyout
 * deliberately skips them (the PromoCodeForm renders its own inline error
 * from `globalErrors[0]`), so an empty envelope there would be SILENT. Give
 * those a message.
 */
export type BasketClientFailure = {
  globalErrors: string[];
  fieldErrors: Record<string, string>;
};

export function buildBasketClientActionFailure(
  body: FormData,
): BasketClientFailure {
  const intent = String(body.get("action") ?? "");
  const globalErrors =
    intent === "addCoupon"
      ? [COUPON_APPLY_FAILED]
      : intent === "removeCoupon"
        ? [COUPON_REMOVE_FAILED]
        : [];
  return { globalErrors, fieldErrors: {} };
}
